export default __webpack_public_path__ + "static/media/Grid-image2-min.42c91516.jpg";